import TranslationService from "../../services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import { isDefined } from "../../helper/utils";
const NotificationService = require("../../services/NotificationService");

export default Vue.component("payment-provider-select", {
    props:
    {
        template:
        {
            type: String,
            default: "#vue-payment-provider-select"
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        noteMap:
        {
            type: Object,
            default: () => ({})
        }
    },

    data()
    {
        return {
            lastAddressComparisonDebugKey: null,
            onGuestAddressChanged: null,
            guestBillingAddressDraft: null,
            guestDeliveryAddressDraft: null
        };
    },

    computed: {
        ...mapState({
            methodOfPaymentList: state => state.checkout.payment.methodOfPaymentList,
            methodOfPaymentId: state => state.checkout.payment.methodOfPaymentId,
            showError: state => state.checkout.validation.paymentProvider.showError,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly,
            selectedShippingProfile: state => state.checkout.shipping.selectedShippingProfile,
            basket: state => state.basket.data,
            basketItems: state => state.basket.items,
            showDeliveryFields: state => state.checkout.showDeliveryFields,
            // Address entered during guest registration (kept for existing behavior)
            newCustomer: state => state.checkout.newCustomer,
            billingAddress: state => state.checkout.newCustomer && state.checkout.newCustomer.billingAddress,
            billingAddressSalutation: state => state.checkout.billingAddressSalutation
        }),
        // Logged-in state from user module
        isLoggedIn()
        {
            return this.$store.getters && this.$store.getters.isLoggedIn;
        },
        // Currently selected addresses from the address module (for logged-in users)
        storeBillingAddress()
        {
            return this.$store.state && this.$store.state.address && this.$store.state.address.billingAddress;
        },
        storeDeliveryAddress()
        {
            return this.$store.state && this.$store.state.address && this.$store.state.address.deliveryAddress;
        },
        paymentNotes()
        {
            if (this.noteMap && typeof this.noteMap === "object")
            {
                return this.noteMap;
            }

            return {};
        }
    },

    /**
     * Initialise the event listener
     */
    created()
    {
        this.$options.template = this.template;
        this.$store.commit("setPaymentProviderValidator", this.validate);
    },
    mounted()
    {
        // Guarded dispatch: only fire afterPaymentMethodChanged when address lists are hydrated
        const addrState = this.$store && this.$store.state && this.$store.state.address;
        const hasLists = addrState && Array.isArray(addrState.billingAddressList) && Array.isArray(addrState.deliveryAddressList);

        if (hasLists)
        {
            document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
        }
        else
        {
            setTimeout(() =>
            {
                const addressState = this.$store && this.$store.state && this.$store.state.address;

                if (addressState && Array.isArray(addressState.billingAddressList) && Array.isArray(addressState.deliveryAddressList))
                {
                    document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
                }
            }, 0);
        }
        // Ensure initial visibility matches current state
        this.updatePaymentVisibility();

        // And once after initial render, in case hydration finalizes values
        this.$nextTick(() =>
        {
            // Re-apply visibility after initial render in case hydration changed state
            this.updatePaymentVisibility();
        });

        this.syncGuestDraftsFromStorage();

        this.onGuestAddressChanged = (event) =>
        {
            if (!this.isLoggedIn)
            {
                const detail = event && event.detail ? event.detail : {};

                this.syncGuestDraftsFromStorage();

                if (detail.addressType === "1")
                {
                    this.guestBillingAddressDraft = Object.assign({}, detail.address || {});
                }
                else if (detail.addressType === "2")
                {
                    this.guestDeliveryAddressDraft = Object.assign({}, detail.address || {});
                }

                this.lastAddressComparisonDebugKey = null;
                this.updatePaymentVisibility();
            }
        };

        document.addEventListener("gonserGuestAddressChanged", this.onGuestAddressChanged);
    },
    beforeDestroy()
    {
        if (this.onGuestAddressChanged)
        {
            document.removeEventListener("gonserGuestAddressChanged", this.onGuestAddressChanged);
        }
    },


    watch:
    {
        // React specifically to delivery address changes for logged-in users
        storeDeliveryAddress:
        {
            handler()
            {
                if (this.isLoggedIn)
                {
                    this.updatePaymentVisibility();
                }
            },
            deep: true
        },
        // React to billing address changes for logged-in users
        storeBillingAddress:
        {
            handler()
            {
                if (this.isLoggedIn)
                {
                    this.updatePaymentVisibility();
                }
            },
            deep: true
        },
        basketItems:
        {
            handler()
            {
                let disabled6019 = false;
                const overLimit = this.basket && this.basket.basketAmount > 4000;
                const hasDeliveryAddressConflict = this.hasDeliveryAddressConflict();
                const hasAvailabilityRestriction = this.hasAvailRule6019();
                const hasBlockedBasketItem = this.hasBlockedBasketItemFor6019();

                this.methodOfPaymentList.forEach(method =>
                {
                    const li = document.querySelector(`li.method-list-item[data-id="${method.id}"]`);

                    // Hide and disable if delivery fields shown OR basket limit exceeded OR shipping address differs OR availability restriction
                    if (
                        this.isTargetPayment(method) &&
                        (overLimit ||
                            hasDeliveryAddressConflict ||
                            hasAvailabilityRestriction ||
                            hasBlockedBasketItem)
                    )
                    {
                        method.isSelectable = false;
                        disabled6019 = true;
                        if (li) li.classList.add("d-none");
                    }
                    else
                    {
                        method.isSelectable = true;
                        if (li) li.classList.remove("d-none");
                    }
                });

                // Deselect if currently selected and should be hidden
                if (
                    disabled6019 &&
                    this.isTargetPaymentSelected()
                )
                {
                    const firstAvailable = this.methodOfPaymentList.find(first => first.isSelectable);

                    if (firstAvailable)
                    {
                        this.onPaymentProviderChange(firstAvailable);
                    }
                }

            },
            deep: true,
            immediate: true
        },
        showDeliveryFields:
        {
            handler()
            {
                let disabled6019 = false;
                const overLimit = this.basket && this.basket.basketAmount > 4000;
                const hasDeliveryAddressConflict = this.hasDeliveryAddressConflict();
                const hasAvailabilityRestriction = this.hasAvailRule6019();
                const hasBlockedBasketItem = this.hasBlockedBasketItemFor6019();

                this.methodOfPaymentList.forEach(method =>
                {
                    if (
                        this.isTargetPayment(method) &&
                        (overLimit ||
                            hasDeliveryAddressConflict ||
                            hasAvailabilityRestriction ||
                            hasBlockedBasketItem)
                    )
                    {
                        method.isSelectable = false;
                        disabled6019 = true;
                    }
                    else
                    {
                        method.isSelectable = true;
                    }
                });

                // Apply DOM changes after render and retry once in case of re-render
                this.$nextTick(() =>
                {
                    const li = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                    if (li)
                    {
                        if (disabled6019)
                        {
                            li.classList.add("d-none");
                        }
                        else
                        {
                            li.classList.remove("d-none");
                        }
                    }

                    setTimeout(() =>
                    {
                        const liRetry = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                        if (liRetry)
                        {
                            if (disabled6019)
                            {
                                liRetry.classList.add("d-none");
                            }
                            else
                            {
                                liRetry.classList.remove("d-none");
                            }
                        }
                    }, 50);
                });

                if (
                    disabled6019 &&
                    this.isTargetPaymentSelected()
                )
                {
                    const firstAvailable = this.methodOfPaymentList.find(first => first.isSelectable);

                    if (firstAvailable)
                    {
                        this.onPaymentProviderChange(firstAvailable);
                    }
                }
            },
            immediate: true
        },
        billingAddress:
        {
            handler()
            {
                let disabled6019 = false;
                const overLimit = this.basket && this.basket.basketAmount > 4000;
                const hasDeliveryAddressConflict = this.hasDeliveryAddressConflict();
                const hasAvailabilityRestriction = this.hasAvailRule6019();
                const hasBlockedBasketItem = this.hasBlockedBasketItemFor6019();

                this.methodOfPaymentList.forEach(method =>
                {
                    if (
                        this.isTargetPayment(method) &&
                        (overLimit ||
                            hasDeliveryAddressConflict ||
                            hasAvailabilityRestriction ||
                            hasBlockedBasketItem)
                    )
                    {
                        method.isSelectable = false;
                        disabled6019 = true;
                    }
                    else
                    {
                        method.isSelectable = true;
                    }
                });

                this.$nextTick(() =>
                {
                    const li = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                    if (li)
                    {
                        if (disabled6019)
                        {
                            li.classList.add("d-none");
                        }
                        else
                        {
                            li.classList.remove("d-none");
                        }
                    }

                });

                if (
                    disabled6019 &&
                    this.isTargetPaymentSelected()
                )
                {
                    const firstAvailable = this.methodOfPaymentList.find(first => first.isSelectable);

                    if (firstAvailable)
                    {
                        this.onPaymentProviderChange(firstAvailable);
                    }
                }
            },
            deep: true,
            immediate: true
        },
        // React to basket changes (includes total changes)
        basket:
        {
            handler()
            {
                this.updatePaymentVisibility();
            },
            deep: true,
            immediate: true
        },
        // React to salutation changes propagated to store
        billingAddressSalutation(value)
        {
            // Simple re-run of basketItems logic to keep behavior consistent
            this.updatePaymentVisibility();
        }
    },

    methods: {
        updatePaymentVisibility()
        {
            let disabled6019 = false;
            const overLimit = this.basket && this.basket.basketAmount > 4000;
            const hasDeliveryAddressConflict = this.hasDeliveryAddressConflict();
            const hasAvailabilityRestriction = this.hasAvailRule6019();
            const hasBlockedBasketItem = this.hasBlockedBasketItemFor6019();

            this.methodOfPaymentList.forEach(method =>
            {
                if (
                    this.isTargetPayment(method) &&
                    (overLimit ||
                        hasDeliveryAddressConflict ||
                        hasAvailabilityRestriction ||
                        hasBlockedBasketItem)
                )
                {
                    method.isSelectable = false;
                    disabled6019 = true;
                }
                else
                {
                    method.isSelectable = true;
                }
            });

            this.$nextTick(() =>
            {
                const li = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                if (li)
                {
                    li.classList.toggle("d-none", disabled6019);
                    li.toggleAttribute("hidden", !!disabled6019);
                    li.style.display = disabled6019 ? "none" : "";
                }

                // Retry hides in case the list re-renders shortly after
                setTimeout(() =>
                {
                    const liRetry = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                    if (liRetry)
                    {
                        liRetry.classList.toggle("d-none", disabled6019);
                        liRetry.toggleAttribute("hidden", !!disabled6019);
                        liRetry.style.display = disabled6019 ? "none" : "";
                        // Also disable the underlying input if present to prevent selection
                        const input = liRetry.querySelector("input[type=radio], input[type=checkbox]");

                        if (input)
                        {
                            input.disabled = !!disabled6019;
                            if (disabled6019 && input.checked)
                            {
                                input.checked = false;
                            }
                        }
                    }
                }, 50);

                setTimeout(() =>
                {
                    const liRetry2 = document.querySelector("li.method-list-item[data-id=\"6019\"]");

                    if (liRetry2)
                    {
                        liRetry2.classList.toggle("d-none", disabled6019);
                        liRetry2.toggleAttribute("hidden", !!disabled6019);
                        liRetry2.style.display = disabled6019 ? "none" : "";
                        const input2 = liRetry2.querySelector("input[type=radio], input[type=checkbox]");

                        if (input2)
                        {
                            input2.disabled = !!disabled6019;
                            if (disabled6019 && input2.checked)
                            {
                                input2.checked = false;
                            }
                        }
                    }
                }, 150);
            });

            if (disabled6019 && this.isTargetPaymentSelected())
            {
                const firstAvailable = this.methodOfPaymentList.find(first => first.isSelectable);

                if (firstAvailable)
                {
                    this.onPaymentProviderChange(firstAvailable);
                }
            }
        },
        getExcludedItemIdsFor6019()
        {
            // Add item IDs that must block payment method 6019.
            return [12398, 12394, 12361, 12360, 12359, 12358];
        },
        getBasketItemId(basketItem)
        {
            return Number(
                basketItem && basketItem.variation && basketItem.variation.data && basketItem.variation.data.item && basketItem.variation.data.item.id
                || basketItem && basketItem.itemId
                || basketItem && basketItem.item && basketItem.item.id
                || 0
            );
        },
        hasBlockedBasketItemFor6019()
        {
            const excludedItemIds = this.getExcludedItemIdsFor6019();

            if (!Array.isArray(excludedItemIds) || excludedItemIds.length === 0)
            {
                return false;
            }

            return this.basketItems.some(basketItem =>
                excludedItemIds.includes(this.getBasketItemId(basketItem))
            );
        },
        hasAvailRule6019()
        {
            return this.basketItems.some(basketItem =>
                basketItem.variation.data.variation.availability.id > 1 &&
                basketItem.variation.data.variation.availability.id < 7
            );
        },
        // Helper: check if a method corresponds to target payment (6019), coercing id to number
        normalizeAddressValue(value)
        {
            return String(value ?? "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/\s+/g, " ")
                .trim();
        },
        normalizeAddressOptions(options)
        {
            if (!Array.isArray(options))
            {
                return [];
            }

            return options
                .map(option =>
                {
                    const typeId = Number(option && option.typeId) || 0;
                    const value = this.normalizeAddressValue(option && option.value);

                    return { typeId, value };
                })
                .filter(option => option.typeId > 0 && option.value.length > 0)
                .sort((left, right) =>
                {
                    if (left.typeId !== right.typeId)
                    {
                        return left.typeId - right.typeId;
                    }

                    return left.value.localeCompare(right.value);
                });
        },
        normalizeAddressForComparison(address)
        {
            if (!address || typeof address !== "object")
            {
                return null;
            }

            const normalizedAddress1 = this.normalizeAddressValue(address.address1);
            const normalizedOptions = this.normalizeAddressOptions(address.options);
            const isPickupAddress = normalizedAddress1 === "packstation" || normalizedAddress1 === "postfiliale";

            return {
                gender: this.normalizeAddressValue(address.gender || address.salutation),
                name1: this.normalizeAddressValue(address.name1),
                name2: this.normalizeAddressValue(address.name2),
                name3: this.normalizeAddressValue(address.name3),
                name4: this.normalizeAddressValue(address.name4),
                address1: normalizedAddress1,
                address2: this.normalizeAddressValue(address.address2),
                address3: this.normalizeAddressValue(address.address3),
                address4: this.normalizeAddressValue(address.address4),
                postalCode: this.normalizeAddressValue(address.postalCode).replace(/\s+/g, ""),
                town: this.normalizeAddressValue(address.town),
                countryId: Number(address.countryId) || 0,
                stateId: Number(address.stateId) || 0,
                options: isPickupAddress
                    ? normalizedOptions.filter(option => option.typeId === 6)
                    : []
            };
        },
        getAddressDiffFields(normalizedBilling, normalizedDelivery)
        {
            if (!normalizedBilling || !normalizedDelivery)
            {
                return [];
            }

            const diffFields = [];
            const keys = Object.keys(normalizedBilling);

            keys.forEach(key =>
            {
                if (JSON.stringify(normalizedBilling[key]) !== JSON.stringify(normalizedDelivery[key]))
                {
                    diffFields.push(key);
                }
            });

            return diffFields;
        },
        logAddressComparison(billingAddress, deliveryAddress, normalizedBilling, normalizedDelivery, isDifferent, reason, diffFields = [])
        {
            const debugPayload = {
                reason,
                billingId: Number(billingAddress && billingAddress.id) || 0,
                deliveryId: Number(deliveryAddress && deliveryAddress.id) || 0,
                normalizedBilling,
                normalizedDelivery,
                isDifferent,
                diffFields
            };
            const debugKey = JSON.stringify(debugPayload);

            if (debugKey === this.lastAddressComparisonDebugKey)
            {
                return;
            }

            this.lastAddressComparisonDebugKey = debugKey;
        },
        getStoredAddress(key)
        {
            if (typeof window === "undefined" || !window.sessionStorage)
            {
                return null;
            }

            try
            {
                const raw = window.sessionStorage.getItem(key);

                return raw ? JSON.parse(raw) : null;
            }
            catch (error)
            {
                return null;
            }
        },
        syncGuestDraftsFromStorage()
        {
            this.guestBillingAddressDraft = this.getStoredAddress("address");
            this.guestDeliveryAddressDraft = this.getStoredAddress("deliveryAddress");
        },
        getGuestBillingAddress()
        {
            return this.guestBillingAddressDraft
                || this.billingAddress
                || (this.newCustomer && this.newCustomer.billingAddress)
                || this.getStoredAddress("address")
                || null;
        },
        hasAddressContent(address)
        {
            if (!address || typeof address !== "object")
            {
                return false;
            }

            const relevantFields = [
                "name1",
                "name2",
                "name3",
                "name4",
                "address1",
                "address2",
                "address3",
                "address4",
                "postalCode",
                "town",
                "countryId"
            ];

            return relevantFields.some(field =>
            {
                if (field === "countryId")
                {
                    return Number(address[field]) > 0;
                }

                return this.normalizeAddressValue(address[field]).length > 0;
            });
        },
        isGuestDeliveryEnabled(guestBillingAddress)
        {
            if (this.showDeliveryFields === true)
            {
                return true;
            }

            if (guestBillingAddress && (
                guestBillingAddress.showDeliveryFields === true
                || guestBillingAddress.showDeliveryFields === "true"
                || guestBillingAddress.showDeliveryFields === 1
                || guestBillingAddress.showDeliveryFields === "1"
            ))
            {
                return true;
            }

            return false;
        },
        getGuestDeliveryAddress()
        {
            return this.guestDeliveryAddressDraft
                || this.getStoredAddress("deliveryAddress")
                || (this.newCustomer && this.newCustomer.deliveryAddress)
                || null;
        },
        isGuestDeliveryDifferent()
        {
            const deliveryAddress = this.getGuestDeliveryAddress();
            const billingAddress = this.getGuestBillingAddress();
            const deliveryEnabled = this.isGuestDeliveryEnabled(billingAddress);

            if (!deliveryEnabled)
            {
                this.logAddressComparison(billingAddress, deliveryAddress, null, null, false, "guest-delivery-disabled");

                return false;
            }

            if (!deliveryAddress)
            {
                this.logAddressComparison(billingAddress, deliveryAddress, null, null, false, "guest-delivery-missing");

                return false;
            }

            if (!billingAddress)
            {
                this.logAddressComparison(billingAddress, deliveryAddress, null, null, false, "guest-billing-missing");

                return false;
            }

            if (!this.hasAddressContent(deliveryAddress) || !this.hasAddressContent(billingAddress))
            {
                this.logAddressComparison(billingAddress, deliveryAddress, null, null, false, "guest-address-incomplete");

                return false;
            }

            const normalizedBilling = this.normalizeAddressForComparison(billingAddress);
            const normalizedDelivery = this.normalizeAddressForComparison(deliveryAddress);
            const diffFields = this.getAddressDiffFields(normalizedBilling, normalizedDelivery);
            const isDifferent = diffFields.length > 0;

            this.logAddressComparison(
                billingAddress,
                deliveryAddress,
                normalizedBilling,
                normalizedDelivery,
                isDifferent,
                "guest-value-compare",
                diffFields
            );

            return isDifferent;
        },
        hasDeliveryAddressConflict()
        {
            if (this.isLoggedIn)
            {
                return this.isDeliveryDifferent();
            }

            return this.isGuestDeliveryDifferent();
        },
        isDeliveryDifferent()
        {
            if (!this.isLoggedIn)
            {
                return false;
            }

            const deliveryAddress = this.storeDeliveryAddress;

            if (!deliveryAddress || typeof deliveryAddress.id === "undefined")
            {
                return false;
            }

            if (Number(deliveryAddress.id) === -99)
            {
                this.logAddressComparison(this.storeBillingAddress, deliveryAddress, null, null, false, "delivery-id--99");

                return false;
            }

            const billingAddress = this.storeBillingAddress || this.billingAddress || null;

            if (!billingAddress)
            {
                this.logAddressComparison(billingAddress, deliveryAddress, null, null, true, "billing-missing");

                return true;
            }

            const normalizedBilling = this.normalizeAddressForComparison(billingAddress);
            const normalizedDelivery = this.normalizeAddressForComparison(deliveryAddress);
            const diffFields = this.getAddressDiffFields(normalizedBilling, normalizedDelivery);
            const isDifferent = diffFields.length > 0;

            this.logAddressComparison(
                billingAddress,
                deliveryAddress,
                normalizedBilling,
                normalizedDelivery,
                isDifferent,
                "value-compare",
                diffFields
            );

            return isDifferent;
        },
        isTargetPayment(method)
        {
            return Number(method && method.id) === 6019;
        },
        // Helper: check if currently selected method is 6019, coercing id to number
        isTargetPaymentSelected()
        {
            return Number(this.methodOfPaymentId) === 6019;
        },
        getPaymentNote(method)
        {
            const methodId = Number(method && method.id);

            return this.paymentNotes[methodId] || "";
        },
        shouldShowPaymentNote(method)
        {
            return Number(method && method.id) === Number(this.methodOfPaymentId) && !!this.getPaymentNote(method);
        },
        getPaymentInputId(method)
        {
            return `paymentMethod${method && method.id}`;
        },
        isMethodDisabled(method)
        {
            return this.isCheckoutReadonly || !method.isSelectable || this.isPaymentMethodExcluded(method.id);
        },
        // eslint-disable-next-line complexity
        /**
         * Event when changing the payment provider
         */
        onPaymentProviderChange(newMethodOfPayment)
        {
            this.$store.dispatch("selectMethodOfPayment", newMethodOfPayment.id)
                .then(data =>
                {
                    document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
                    this.updatePaymentVisibility();
                },
                error =>
                {
                    this.updatePaymentVisibility();
                    // swallow error or handle with NotificationService if desired
                });

            this.validate();
        },

        validate()
        {
            const showError = !(this.methodOfPaymentId > 0);

            this.$store.commit("setPaymentProviderShowError", showError);

            this.updatePaymentVisibility();

            if (showError)
            {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckPaymentProvider")
                );
            }
        },
        isPaymentMethodExcluded(paymentMethodId)
        {
            if (isDefined(this.selectedShippingProfile?.excludedPaymentMethodIds))
            {
                return this.selectedShippingProfile.excludedPaymentMethodIds.includes(paymentMethodId);
            }
            else
            {
                return false;
            }
        }
    }
});
